import { Component, OnInit } from '@angular/core';
import {
  BreadcrumbComponent,
  BreadcrumbComponentEvent,
  LooseDatePipe, MessageBoxComponent,
  setupUntilDestroy,
  TagBoxComponent
} from '@portal-workspace/grow-ui-library';
import { CustomerUser, PismoTransactionsIncludingPending, GetPismoTransactionsFn, GetTransactionDetailsFn,
   GetPismoAccountDetailsFn, GetCardFn, GetTransactionFromTimelineFn ,ClearPendingTransactionFn} from '@portal-workspace/grow-shared-library';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { MatSortModule } from '@angular/material/sort';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from '@angular/router';
import {
  navigationUrlForCustomerDetails,
} from '../../service/navigation-urls';
import { CustomPaginatorComponent,CustomContentLoaderComponent } from '@portal-workspace/grow-ui-library';
import { MatTableModule } from '@angular/material/table';
import { ExtendedModule } from '@angular/flex-layout/extended';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout/flex';
import { NgClass, AsyncPipe, DatePipe, NgStyle } from '@angular/common';
import { MatDividerModule } from '@angular/material/divider';
import { OverdraftCustomerService } from '../../service/overdraft-customer.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import _ from 'lodash';
import { OverdraftAccountTransactionsComponent } from "@portal-workspace/grow-ui-library";

export class InternalDataSource implements DataSource<PismoTransactionsIncludingPending> {

  subject: BehaviorSubject<PismoTransactionsIncludingPending[]> = new BehaviorSubject<PismoTransactionsIncludingPending[]>([]);

  connect(collectionViewer: CollectionViewer): Observable<PismoTransactionsIncludingPending[]> {
    return this.subject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.subject.complete();
  }

  update(c: PismoTransactionsIncludingPending[]) {
    this.subject.next(c);
  }
}

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
  templateUrl: './pismo-display-transactions.page.html',
  styleUrls: ['./pismo-display-transactions.page.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  standalone: true,
  imports: [
    FlexModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    CustomContentLoaderComponent,
    NgClass,
    ExtendedModule,
    MatTableModule,
    MatSortModule,
    CustomPaginatorComponent,
    AsyncPipe,
    MatDividerModule,
    DatePipe,
    LooseDatePipe,
    BreadcrumbComponent,
    TagBoxComponent,
    NgStyle,
    OverdraftAccountTransactionsComponent,
    MessageBoxComponent
]
})
export class PismoDisplayTransactionsPage implements OnInit {

  stage : 'init' | 'done' | 'error' = 'init';

  breadcrumbTrails: string[] = ['Admin', 'Customer'];
  subscriptions: Subscription[] = [];
  pismoAccountNumber !: number
  customer: CustomerUser | null = null;

  getPismoTransactionsFn!: GetPismoTransactionsFn;
  getTransactionDetailsFn!: GetTransactionDetailsFn;
  getPismoAccountDetailsFn!: GetPismoAccountDetailsFn;
  getTransactionFromTimelineFn!: GetTransactionFromTimelineFn;
  clearPendingTransactionFn!: ClearPendingTransactionFn;
  getCardFn!: GetCardFn;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private overdraftCustomerService: OverdraftCustomerService,
    // private toastService: PortalHotToastService
  ) {
    this.getPismoTransactionsFn = this.overdraftCustomerService.getPismoTransactionsFn;
    this.getTransactionDetailsFn = this.overdraftCustomerService.getTransactionDetailsFn;
    this.getPismoAccountDetailsFn = this.overdraftCustomerService.getPismoAccountDetailsFn;
    this.getCardFn = this.overdraftCustomerService.getCardFn;
    this.getTransactionFromTimelineFn = this.overdraftCustomerService.getTransactionFromTimelineFn;
    this.clearPendingTransactionFn = this.overdraftCustomerService.clearPendingTransactionFn;
  }

  ngOnInit() {
    setupUntilDestroy(this);
    this.pismoAccountNumber = this.activatedRoute.snapshot.params.pismoAccountNumber;
    this.customer = (this.activatedRoute.snapshot.data as any).customerUser;
    const customerName = this.customer?.EntityName
    if (customerName) {
      this.breadcrumbTrails.push(customerName, 'Overdraft Account Details', `Account # ${this.pismoAccountNumber}`);
    }
    if (this.pismoAccountNumber && this.customer) {
      this.stage = 'done';
    } else {
      this.stage = 'error';
    }
  }

  async onBreadcurmbEvents($event: BreadcrumbComponentEvent) {
    await this.router.navigate(navigationUrlForCustomerDetails(this.customer?.CustomerId!))
  }

}
